var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalKontainer",
    attrs: {
      "id": "modal-kontainer",
      "title": "Tambah Kontainer",
      "variant": "success",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoadingModal,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addKontainer($event)
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Kontainer"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:11'),
      expression: "'required|min:11'"
    }],
    class: _vm.errors.has('Nomor Kontainer') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "maxlength": "11",
      "name": "Nomor Kontainer",
      "placeholder": "Nomor Kontainer"
    },
    model: {
      value: (_vm.kontainer.no_kontainer),
      callback: function($$v) {
        _vm.kontainer.no_kontainer = $$v
      },
      expression: "kontainer.no_kontainer"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nomor Kontainer')),
      expression: "errors.has('Nomor Kontainer')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nomor Kontainer')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Ukuran Kontainer"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "Feet"
    }
  }, [_c('b-form-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Ukuran Kontainer') ? 'is-invalid' : '',
    attrs: {
      "plain": true,
      "name": "Ukuran Kontainer",
      "options": ['20', '40', '45']
    },
    model: {
      value: (_vm.kontainer.ukuran_kontainer),
      callback: function($$v) {
        _vm.kontainer.ukuran_kontainer = $$v
      },
      expression: "kontainer.ukuran_kontainer"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Ukuran Kontainer')),
      expression: "errors.has('Ukuran Kontainer')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Ukuran Kontainer')) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kontainer"
    }
  }, [_c('b-form-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jenis Kontainer') ? 'is-invalid' : '',
    attrs: {
      "plain": true,
      "name": "Jenis Kontainer",
      "options": [{
        text: 'FCL',
        value: 'F'
      }, {
        text: 'LCL',
        value: 'L'
      }]
    },
    model: {
      value: (_vm.kontainer.jns_kontainer),
      callback: function($$v) {
        _vm.kontainer.jns_kontainer = $$v
      },
      expression: "kontainer.jns_kontainer"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kontainer')),
      expression: "errors.has('Jenis Kontainer')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Kontainer')) + "\n          ")])], 1)], 1)]), _vm._v(" "), _vm._t("default", [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah\n      ")])], {
    id: "footer"
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ee4cd8a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/modal/ModalKontainer.vue
// module id = 353
// module chunks = 0